import { DataDocument, tagsTemplateDirectoryId } from '@fillip/api';

export const TemplateTagStyledText: DataDocument = {
  id: 'tag-styledText',
  parentId: tagsTemplateDirectoryId,
  info: {
    title: 'Styled Text',
    icon: 'text-size',
    isProtected: true,
  },
  element: {
    type: 'element.styledText',
    htmlContent: ':$text',
  },
  class: {
    class: ':`${$containerClasses}`',
    elementClass: ':`${$elementClasses}`',
  },
  tag: {
    tag: 'tag',
  },
  tagDefinition: {
    tag: 'styledText',
    title: 'Styled Text',
    category: 'content',
    icon: 'text-size',
    editor: 'styledText',
  },
  interfaceDefinition: {
    title: '',
    inheritFrom: 'baseContent',
    props: [
      {
        title: 'Container Classes',
        key: 'containerClasses',
        type: 'string',
        defaultValue:
          ":`${$$contentTagClasses} ${$$textClasses} ${$containerClasses || properties?.containerClasses?.value || ''}`",
      },
      {
        title: 'Element Classes',
        key: 'elementClasses',
        type: 'string',
        defaultValue:
          ":`${$elementClasses || properties?.elementClasses?.value || ''}`",
      },
    ],
  },
};
